import { useEffect, useRef } from 'react';
import createHostCodeWatcher from 'react/match/hostCode/hostCodeWatcher';
import alertHostCode from 'react/match/hostCode/alertHostCode';

// Announces the opponent's new host code once, on every page: the dock is
// mounted on all of them and sees every update of the current match.
export default function useHostCodeAlert(currentMatch, currentMatchUpdateIndex) {
	const watcher = useRef(null);
	if(!watcher.current) {
		watcher.current = createHostCodeWatcher();
	}
	useEffect(() => {
		const hostCode = watcher.current.newOpponentCode(currentMatch);
		if(hostCode) {
			alertHostCode(currentMatch, hostCode);
		}
	}, [currentMatch, currentMatchUpdateIndex]);
}
